import { Event, EventType } from './event.model'
import { Group } from './group.model'

import { Picture } from './picture.model'

import * as moment from 'moment'
moment.locale('fr')

export interface IEventRequestData {
  id: string
  type: string
  title: string
  body: string
  beginAt: moment.Moment
  endAt: moment.Moment
  address: string
  city: string
  zipcode: string
  country: string
  recurring: boolean
  startFeaturing: moment.Moment
  endFeaturing: moment.Moment
  groups: Group[]
  pictures: string[]
}

export class EventForm {
  public id: string
  public type: string
  public title: string
  public body: string
  public beginAt: moment.Moment
  public endAt: moment.Moment
  public address: string
  public city: string
  public zipcode: string
  public country: string
  public recurring: boolean
  public startFeaturing: moment.Moment
  public endFeaturing: moment.Moment
  public groups: Group[]
  public pictures: Picture[] = []

  fill (event: Event) {
    this.id = event.id
    this.type = EventType[event.type]
    this.title = event.title
    this.body = event.body
    this.beginAt = event.beginAt
    this.endAt = event.endAt
    this.address = event.address
    this.city = event.city
    this.zipcode = event.zipcode
    this.country = event.country
    this.recurring = event.recurring
    this.startFeaturing = event.startFeaturing
    this.endFeaturing = event.endFeaturing
    this.groups = event.groups
    this.pictures = event.pictures.map((pic) => pic)
  }

  update (event: Event) {
    event.id = this.id
    event.type = EventType[this.type]
    event.title = this.title
    event.body = this.body
    event.beginAt = this.beginAt
    event.endAt = this.endAt
    event.address = this.address
    event.city = this.city
    event.zipcode = this.zipcode
    event.country = this.country
    event.recurring = this.recurring
    event.startFeaturing = this.startFeaturing
    event.endFeaturing = this.endFeaturing
    event.groups = this.groups
    event.pictures = this.pictures
  }

  generateSelectType () {
    return Object.keys(EventType)
      .filter(key => !isNaN(parseInt(key, 10)) && parseInt(key, 10) !== EventType.member_birth)
      .map((el, index) => ({
        value: EventType[el],
        label: new Event().getTypeLabel(parseInt(el, 10))
      }))
      .sort((a,b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) return -1
        else if (a.label.toLowerCase() > b.label.toLowerCase()) return 1
        return 0
      })
  }

  toRequestData (): IEventRequestData {
    return {
      id: this.id,
      type: this.type,
      title: this.title,
      body: this.body,
      beginAt: this.beginAt,
      endAt: this.endAt,
      address: this.address,
      city: this.city,
      zipcode: this.zipcode,
      country: this.country,
      recurring: this.recurring,
      startFeaturing: this.startFeaturing,
      endFeaturing: this.endFeaturing,
      groups: this.groups,
      pictures: this.pictures.map(pic => pic.url)
    }
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/models/event-form.model.ts